import { createCRUDHook } from './createCRUDHook';
import { rmaItemDto } from 'utils/models';
import { CREATE_BULK_ENTITY, RMA_ORDER_ITEM } from './apiEndPoints';
import { AxiosResponse } from 'axios';

interface RMAItemCustomOperations {
  addBulkRMAItemData: (param: rmaItemDto[]) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  rmaItemDto,
  rmaItemDto[],
  RMAItemCustomOperations
>({
  entityName: 'RMAItem',
  endpoint: RMA_ORDER_ITEM,
  customOperations: (auth) => ({
    addBulkRMAItemData: async (param: rmaItemDto[]): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          RMA_ORDER_ITEM + CREATE_BULK_ENTITY,
          param
        );
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const RMAItemContext = Context;
export const useRMAItemManager = useManager;
export const useRMAItem = useConsumer;
